import React, { useState, useEffect } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  Form,
  Label,
  Input,
  Button,
  Row,
  Col,
  TabContent,
  TabPane,
  Spinner
} from "reactstrap";
import { connect } from "react-redux";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserCircle,
  faChevronDown,
  faBell,
  faComments
} from "@fortawesome/free-solid-svg-icons";

import {
  getCategories,
  getSubcategories
} from "../../providers/categoryProvider";
import "./professionalInfo.css";
import Tag from "../tag/Tag";
import {
  updateProfessionalAccount,
  uploadImage
} from "../../providers/userProvider";
import Toast from "../utils/Toast";
import {
  sendDocument,
  getProfessionalInfo
} from "../../providers/professionalProvider";

const DAYS = {
  MONDAY: "Segunda",
  TUESDAY: "Terça",
  WEDNESDAY: "Quarta",
  THURSDAY: "Quinta",
  FRIDAY: "Sexta",
  SATURDAY: "Sábado",
  SUNDAY: "Domingo"
};

let scheduleDefault = [];

Object.keys(DAYS).forEach(key => {
  let day = key.toLowerCase();
  scheduleDefault.push({
    day,
    begin: day == "saturday" || day == "sunday" ? "" : "09:00",
    end: day == "saturday" || day == "sunday" ? "" : "18:00"
  });
});

class ProfessionalInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeComponent: 0,
      photo: "",
      photoFile: "",
      tags: [],
      newTag: "",
      category: "",
      description: "",
      chatPrice: "",
      videoPrice: "",
      personalId: null,
      personalIdName: "",
      professionalDocumentation: null,
      professionalDocumentationName: "",
      beginTime: "",
      endTime: "",
      activeTab: DAYS.MONDAY,
      schedule: scheduleDefault,
      loading: false,
      invalid: "",
      holder_name: "",
      bank_account: "",
      bank_agency: "",
      account_taxpayer: "",
      subcategories: [],
      subcategory: []
    };
  }

  async componentDidMount() {
    //this.props.doGetCategories();
    //console.log(this.props.user);
    const result = await getProfessionalInfo(
      this.props.user._id,
      this.props.user.token
    );
    //console.log(result);

    const {
      professionalDescription,
      chatPrice,
      videoPrice,
      categoryId,
      subcategories
    } = result;

    const category = this.props.categories.find(
      item => item._id === categoryId._id
    );

    if (category.hasSubcategory) {
      const subcategoriesResult = await getSubcategories(categoryId._id);
      if (!subcategoriesResult.error) {
        this.setState({ subcategories: subcategoriesResult });
      }
    }

    this.setState({
      description: professionalDescription ? professionalDescription : "",
      chatPrice: chatPrice,
      videoPrice: videoPrice,
      category: categoryId._id,
      subcategory: subcategories
    });
  }

  addTag = e => {
    e.preventDefault();
    const newTag = {
      name: this.state.newTag
    };
    const oldTags = this.state.tags;

    if (oldTags.some(item => item.name === newTag.name)) {
      return;
    }

    this.setState({ tags: [...oldTags, newTag], newTag: "" });
  };

  setInvalidMessage(message) {
    this.setState({ invalid: message });
    setTimeout(() => {
      this.setState({ invalid: "" });
    }, 1000);
  }

  isValid() {
    /* if(!this.state.category){
            return false;
        } */

    /* if (!this.state.description) {
      this.setInvalidMessage("É necessáro adicionar uma descrição");
      return false;
    } */

    if (!this.state.chatPrice) {
      this.setInvalidMessage("É necessáro adicionar um preço para o chat");
      return false;
    }

    return true;
  }

  submit = async e => {
    this.setState({ loading: true });
    e.preventDefault();

    if (!this.isValid()) {
      return;
    }
    //console.log(this.state);

    const {
      description,
      chatPrice,
      videoPrice,
      category,
      subcategory,
      personalId,
      professionalDocumentation
    } = this.state;

    let payload = {
      professionalDescription: description,
      chatPrice,
      videoPrice,
      categoryId: category,
      subcategories: subcategory
    };

    if (personalId) {
      const result = await uploadImage(personalId, this.props.user.token);
      if (!result.error) payload.userIdDocument = result.url;
    }

    if (professionalDocumentation) {
      const result = await uploadImage(
        professionalDocumentation,
        this.props.user.token
      );
      if (!result.error) payload.professionalDocument = result.url;
    }

    //console.log(payload);
    const result = await updateProfessionalAccount(
      this.props.user._id,
      this.props.user.token,
      payload
    );
    //console.log(result);

    this.setState({ loading: false });
  };

  onChange(updateObj) {
    this.setState(prevState => ({
      ...prevState,
      ...updateObj
    }));
  }

  async onSelectCategory(categoryId) {
    //console.log(categoryId);
    this.onChange({ category: categoryId });
    const category = this.props.categories.find(
      item => item._id === categoryId
    );
    //console.log(category);
    if (category.hasSubcategory) {
      const result = await getSubcategories(categoryId);
      if (result.error) return;
      //console.log(result);

      this.setState({ subcategories: result, subcategory: [] });
    } else {
      this.setState({ subcategories: [], subcategory: [] });
    }
  }

  onSelectSubcategory(subcategoryId) {
    const contains = this.state.subcategory.includes(subcategoryId);
    //console.log(contains);
    if (contains) {
      //console.log("should exclude");
      this.setState({
        subcategory: this.state.subcategory.filter(
          item => item !== subcategoryId
        )
      });
      return;
    }
    this.setState({ subcategory: [...this.state.subcategory, subcategoryId] });
  }

  onChangeSchedule(day, updateObj) {
    let schedule = this.state.schedule.map(weekDay => {
      if (weekDay.day == day.toLowerCase()) {
        return {
          ...weekDay,
          ...updateObj
        };
      }
      return weekDay;
    });
    this.setState({ schedule });
  }

  toggleTab(newTab) {
    this.setState({ activeTab: newTab });
  }

  //tags, horario, valor de video e chat, descricao profissional

  renderDays = () => (
    <React.Fragment>
      <Label>Horários disponíveis</Label>
      <Nav tabs>
        {Object.values(DAYS).map(day => (
          <NavItem key={day}>
            <NavLink
              className={classnames({ active: this.state.activeTab === day })}
              onClick={() => this.toggleTab(day)}
            >
              {day}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <TabContent
        activeTab={this.state.activeTab}
        className="schedule-container"
      >
        {Object.entries(DAYS).map(([key, value], index) => (
          <TabPane key={key} tabId={value}>
            <Row>
              <Col>
                <Label for="begin-time">de:</Label>
                <Input
                  id="begin-time"
                  type="time"
                  value={this.state.schedule[index].begin}
                  onChange={e =>
                    this.onChangeSchedule(key, { begin: e.target.value })
                  }
                />
              </Col>
              <Col>
                <Label for="end-time">até:</Label>
                <Input
                  id="end-time"
                  type="time"
                  value={this.state.schedule[index].end}
                  onChange={e =>
                    this.onChangeSchedule(key, { end: e.target.value })
                  }
                />
              </Col>
            </Row>
          </TabPane>
        ))}
      </TabContent>
    </React.Fragment>
  );

  renderForm = () => (
    <Form className="professional-form">
      {/* <div>
        <Label className="image-label" htmlFor="image-input">
          {this.state.photo ? (
            <img src={this.state.photo} className="profile-avatar" />
          ) : (
            <FontAwesomeIcon
              icon={faUserCircle}
              color="#F0802E"
              className="profile-icon"
            />
          )}
          Escolha uma foto
        </Label>
        <Input
          id="image-input"
          type="file"
          accept="image/png, image/jpg"
          onChange={e => this.uploadPicture(e)}
        />
      </div> */}

      <Label for="category-select">Selecione sua categoria</Label>
      <Input
        type="select"
        name="category"
        id="category-select"
        onChange={e => this.onSelectCategory(e.target.value)}
        value={this.state.category}
      >
        <option disabled value={""}>
          Sua categoria
        </option>
        {this.props.categories.map(item => (
          <option key={item._id} value={item._id}>
            {item.name}
          </option>
        ))}
      </Input>

      {this.state.subcategories.length > 0 ? (
        <React.Fragment>
          <Label for="category-select">Selecione sua subcategoria</Label>
          <Input
            type="select"
            name="subcategory"
            id="subcategory-select"
            onChange={e => {}}
            value={this.state.subcategory}
            multiple
          >
            {this.state.subcategories.map(item => (
              <option
                onClick={() => this.onSelectSubcategory(item._id)}
                key={item._id}
                value={item._id}
              >
                {item.name}
              </option>
            ))}
          </Input>
        </React.Fragment>
      ) : null}

      <Label for="description">Descrição Profissional</Label>
      <Input
        type="textarea"
        id="description"
        value={this.state.description}
        onChange={e => this.onChange({ description: e.target.value })}
      />

      {/* <Row>
        <Col md="6">
          <Label for="chat-value">Preço para chat</Label>
          <Input
            id="chat-value"
            type="number"
            value={this.state.chatPrice}
            onChange={e => this.onChange({ chatPrice: e.target.value })}
          />
        </Col>

        <Col md="6">
          <Label for="video-value">Preço para vídeo</Label>
          <Input
            id="video-value"
            type="number"
            value={this.state.videoPrice}
            onChange={e => this.onChange({ videoPrice: e.target.value })}
          />
        </Col>
      </Row> */}

      <Row>
        <Col md="6">
          <Label for="personal-id">Identidade</Label>
          <Input
            id="personal-id"
            type="file"
            value={this.state.personalIdName}
            onChange={e =>
              this.onChange({
                personalId: e.target.files[0],
                personalIdName: e.target.value
              })
            }
          />
        </Col>

        <Col md="6">
          <Label for="professional-document">Comprovação Profissional</Label>
          <Input
            id="professional-document"
            type="file"
            value={this.state.professionalDocumentationName}
            onChange={e =>
              this.onChange({
                professionalDocumentation: e.target.files[0],
                professionalDocumentationName: e.target.value
              })
            }
          />
        </Col>
      </Row>

      {/* <h3 className="mt-3 mb-0">Informações bancárias</h3>

      <Row>
        <Col xs="6" md="2">
          <Label for="bank-account">Agência</Label>
          <Input
            value={this.state.bank_agency}
            onChange={e => this.onChange({ bank_agency: e.target.value })}
          />
        </Col>

        <Col xs="6" md="2">
          <Label>Conta</Label>
          <Input
            value={this.state.bank_account}
            onChange={e => this.onChange({ bank_account: e.target.value })}
          />
        </Col>

        <Col md="4">
          <Label>CPF/CNPJ</Label>
          <Input
            value={this.state.account_taxpayer}
            onChange={e => this.onChange({ account_taxpayer: e.target.value })}
          />
        </Col>

        <Col md="4">
          <Label>Nome do titular</Label>
          <Input
            value={this.state.holder_name}
            onChange={e => this.onChange({ holder_name: e.target.value })}
          />
        </Col>
      </Row> */}

      {/* this.renderDays() */}

      {/* <Label for="new-tag">Adicione tags</Label>
            <div className="d-flex">
                <Input 
                    id="new-tag"
                    value={this.state.newTag}
                    onChange={e => this.onChange({newTag:e.target.value})}
                />
                <Button onClick={this.addTag}>Adicionar</Button>
            </div>

            <Label>Tags</Label>
            <div>
                {this.state.tags.length < 1 ? (
                    <p>Adicione tags para ser encontrado mais facilmente</p>
                ) : null}
                {this.state.tags.map(tag => (
                    <Tag name={tag.name} key={tag.name}
                        delete={() => this.setState({tags: this.state.tags.filter(item => item.name != tag.name)})}
                    />
                ))}
            </div> */}

      <Button onClick={e => this.submit(e)} className="submit-btn">
        {this.state.loading ? <Spinner color="light" size="sm" /> : "Salvar"}
      </Button>
    </Form>
  );

  handleComponent = value => {
    switch (value) {
      case 0:
        return this.renderForm();
    }
  };

  isActive = tab => {
    let className = null;
    if (tab === this.state.activeComponent) {
      className = "active";
    }
    return className;
  };

  render() {
    const { successMessage, errorMessage } = this.props;

    return (
      <div className="col-md-12">
        <div className="mt-4">
          <h2 id="tipo-texto">Perfil Profissional</h2>
        </div>
        <Nav className="nav-account-content">
          <NavItem>
            <NavLink
              href="#"
              onClick={() => this.setState({ activeComponent: 0 })}
              className={this.isActive(0)}
            >
              Informações profissionais
            </NavLink>
          </NavItem>
        </Nav>
        <div className="profile-card">
          {this.handleComponent(this.state.activeComponent)}
        </div>
        {successMessage ? (
          <Toast message={successMessage} type="success" />
        ) : null}
        {errorMessage ? <Toast message={errorMessage} type="error" /> : null}
        {this.state.invalid ? (
          <Toast message={this.state.invalid} type="error" />
        ) : null}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doGetCategories: () => dispatch(getCategories())
    /* doUpdateProfessionalAccount: (uid, payload) =>
      dispatch(updateProfessionalAccount(uid, payload)) */
    /* sendImage: image => dispatch(sendImage(image)) */
  };
};
const mapStateToProps = state => {
  return {
    categories: state.category.list,
    successMessage: state.user.updateAccountSuccessMsg,
    errorMessage: state.user.updateAccountError,
    user: state.user.userInfo,
    updateLoading: state.user.updateLoading
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfessionalInfo);
